/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Permissions_ClearInputs */

const vi_api_keys_permissions_clear = /** @type {(inputs: Api_Keys_Permissions_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ chọn tất cả`)
};

/**

* @param {Api_Keys_Permissions_ClearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_permissions_clear = /** @type {((inputs?: Api_Keys_Permissions_ClearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Permissions_ClearInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_permissions_clear(inputs)
});